<div mat-subheader *ngIf="item.Name" class="nav-caption txt-customMenuParent">
  <div *ngIf="!item.isCollapsed" (click)="toggleMenu()" (click)="onSelectedItem(item)" class="menu-toggle">
    <i-tabler *ngIf="item.Icon" class="routeIcon icon__customMenuParent icon__customParent" name="{{ item.Icon }}"></i-tabler>
    <span>
      <!-- {{item.Name}} -->
      {{ 'SIDEBAR.' + item.Name | translate }}
    </span>
  </div>
  <div *ngIf="item.isCollapsed" (click)="onSelectedItem(item)" class="menu-toggle">
    <i-tabler *ngIf="item.Icon" class="routeIcon icon__customMenuParent icon__customParent" name="{{ item.Icon }}"></i-tabler>
    <span>
      {{ 'SIDEBAR.' + item.Name | translate }}
        <!-- {{item.Name}} -->
    </span>
  </div>
  <i *ngIf="!item.isCollapsed && !isCollapsed" class="ti ti-caret-right-filled icon__customChild" [ngClass]="{'ti-caret-right-filled': !isExpanded, 'ti-caret-down-filled': isExpanded}"
  (click)="toggleMenu()"></i>
</div>
<div *ngIf="isExpanded">
  <a mat-list-item (click)="onItemSelected(item, menuChild)" [ngClass]="{
    'mat-toolbar mat-primary activeMenu': menuChild.Url
      ? router.isActive('/' + item.Url + '/' + menuChild.Url, true)
      : false,
  }" class="menu-list-item" style="margin-left: unset !important;" *ngFor="let menuChild of item.listMenus">
  <i-tabler class="routeIcon icon__customMenuChild" name="{{ menuChild.Icon }}" matListItemIcon></i-tabler>
  <span class="txt-customMenuChild">{{ 'SIDEBAR.' + menuChild.Name | translate }}</span>
  </a>
</div>

